import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogoMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-[#061235] px-5 text-white">
      <form onSubmit={submit} data-testid="admin-login-form" className="chamfer w-full max-w-md border border-white/15 bg-[#0B1D4F] p-8">
        <LogoMark className="h-16 w-auto" />
        <h1 className="font-display mt-6 text-4xl font-black uppercase">Admin sign in</h1>
        <p className="mt-2 text-sm text-slate-300">Jobs and submissions. Staff only.</p>
        <div className="mt-6 space-y-4">
          <div><Label htmlFor="l-email">Email</Label><Input id="l-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="h-12 rounded-none border-white/15 bg-[#061235]" /></div>
          <div><Label htmlFor="l-pw">Password</Label><Input id="l-pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="h-12 rounded-none border-white/15 bg-[#061235]" /></div>
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-300">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="mt-6 w-full bg-[#C8102E] py-4 font-semibold text-white disabled:opacity-60">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
